import React, {useRef, useEffect} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './edit'
import { HomeOutlined, UnorderedListOutlined, TagsOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Tag} from 'antd';
import {getAll, dropManual} from '../../../../apis/OdooLeaveTypeApi';
import { getClaseAusenciaText, getClaseAusenciaColor } from '../../../../constants/claseAusencia';

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Configuración</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Recursos Humanos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <TagsOutlined />
        <span>Tipos de Ausencia</span>
      </>
    ),
}];

const OdooLeaveTypePage = () => {
    const [items, setItems] = React.useState([]);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [itemSelected, setItemSelected] = React.useState(null);

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: 80,
      },
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Clase',
        dataIndex: 'clase',
        key: 'clase',
        width: 160,
        render: (clase) => (
          <Tag color={getClaseAusenciaColor(clase)}>
            {getClaseAusenciaText(clase)}
          </Tag>
        )
      },
      {
        title: 'Máx. Permisos',
        dataIndex: 'max_leaves',
        key: 'max_leaves',
        width: 120,
        render: (max_leaves) => max_leaves?.toFixed(2) || '0.00'
      },
      {
        title: 'Activo',
        dataIndex: 'active',
        key: 'active',
        width: 100,
        render: (active) => (
          <Tag color={active ? 'green' : 'red'}>
            {active ? 'Activo' : 'Inactivo'}
          </Tag>
        )
      },
      {
        title: 'Acciones',
        dataIndex: 'actions',
        key: 'actions',
        width: 200,
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setItemSelected(object);
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setItemSelected(null);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas que deseas eliminar este tipo de permiso?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar esta información',
            onOk: () => deleteOk(item.id),
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id) => {
      const response = await dropManual(id);
      if(response.ok){
        message.success('¡El tipo de permiso ha sido eliminado!');
        await refreshData();
      }
      else{
        message.error('¡Error al eliminar el tipo de permiso!');
      }
    }

    const onHandlerFinish = async (refresh,  avoidClose) => {
      if(!avoidClose){
        setOpenEdit(false);
      }

      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }
    }

    const effectRan = useRef(false);
    useEffect(() => {
      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    
    return <PageApp 
      routes={routes}
      title={'Tipos de Ausencia'}
      extraCard={[
          <Button type="primary" onClick={btnClick}>
            Agregar Tipo de Ausencia
          </Button>
        ]}
    >
      {
          items.length == 0 ? <Empty />:
          <Table dataSource={items} columns={columns} rowKey="id" />
      }
      {
        (openEdit && itemSelected && itemSelected.id > 0) &&
        <ModalEdit title={"Editar Tipo de Permiso"} id={itemSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !itemSelected) &&
        <ModalEdit title={"Crear Tipo de Permiso"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default OdooLeaveTypePage;